export enum Bucket {
  temporaryUploads = 'temporaryUpload',
  data = 'data',
  pedigreePictures = 'pedigreePicture'
}



// WEBPACK FOOTER //
// ./src/app/models/bucket.enum.ts